import { Sparkles } from "lucide-react";

/**
 * KI-Badge im Meta/Instagram-Stil: dezent, aber unübersehbar oben rechts.
 * Wird über Bildern, Videos und 360°-Viewern eingeblendet, sobald das
 * zugehörige Media-Objekt `is_ai_generated === true` ist.
 *
 * Positionierung:
 *  - Default: `absolute` in einem `relative`-Container. Der Aufrufer
 *    stellt sicher, dass der Wrapper `position: relative` hat.
 *  - Für Vollbild-Modi / Lightboxes: gleicher Renderer, gleicher Marker,
 *    der Layer-Container ist immer der äußere Bild-Wrapper.
 */

type Props = {
    /** Position rendern, wenn `false` → gar nichts. */
    show?: boolean;
    /** Optional: eigene className am Root (nur additiv, überschreibt nicht). */
    className?: string;
    /** Für spezielle Größenkontexte (z. B. Slider-Vergleich): kleiner. */
    size?: "sm" | "md";
    /** Test-Selector. Idealerweise pro Media-ID eindeutig. */
    testId?: string;
};

export default function AiBadge({ show = true, className, size = "md", testId }: Props) {
    if (!show) return null;
    const isSm = size === "sm";
    return (
        <span
            className={
                (className ? className + " " : "") +
                "pointer-events-none absolute top-2 right-2 z-10 inline-flex items-center gap-0.5 rounded-full backdrop-blur-sm"
            }
            style={{
                background: "rgba(23, 22, 19, 0.7)",
                color: "#D4A574",
                padding: isSm ? "1px 4px" : "2px 5px",
                fontSize: isSm ? 7 : 8,
                fontWeight: 600,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                border: "1px solid rgba(215, 170, 100, 0.25)",
                boxShadow: "0 3px 8px -3px rgba(0, 0, 0, 0.35)",
            }}
            data-testid={testId || "ai-badge"}
            aria-label="KI-generiertes Bild"
        >
            <Sparkles
                size={isSm ? 7 : 8}
                strokeWidth={2}
                aria-hidden="true"
                style={{ color: "#EBD5A0" }}
            />
            KI
        </span>
    );
}
